import { useMutation } from '@apollo/client/react';
import { useResetAtom } from 'jotai/utils';
import { useCallback } from 'react';

import { RequestAppointmentDocument } from '~/graphql/generated/graphql';
import { requestAppointmentModalState } from '~/state/reception/atoms';

type Props = {
  draftAppointmentId: string;
};

export const useRequestAppointment = (props: Props) => {
  const [request, { error, loading }] = useMutation(RequestAppointmentDocument);
  const resetModalState = useResetAtom(requestAppointmentModalState);

  const handleRequest = useCallback(async () => {
    try {
      await request({
        variables: {
          input: {
            draftAppointmentId: props.draftAppointmentId,
          },
        },
      });

      resetModalState();
    } catch {
      // 何もしない
    }
  }, [props.draftAppointmentId, request, resetModalState]);

  return {
    loading,
    error,
    handleRequest,
  };
};
